import { shallowRef, defineAsyncComponent, reactive } from "vue";

import { $_FilterObject } from "@/config/filter";

import { Format, Helpers, ObjectLib } from "@/core/utils";

export const FilterGroups =
[
    { id: 'settings', label: 'Basic filters', icon: 'isax-filter5' },
    { id: 'range', label: 'Range filters', icon: 'isax-arrange-circle-25' },
    { id: 'date', label: 'Date filters', icon: 'isax-calendar5' }
];

const $_combineFilters = ( ...filters ) =>
{
    let mergedFilter = {};

    filters.forEach( ( filter ) => { mergedFilter = ObjectLib.merge( mergedFilter, filter ); });

    return mergedFilter;
}

const $_updateFilter = ( settings, ctx ) =>
{
    let $_filter = {}, activeFilter = settings.filters.find( p => p.active );

    if( activeFilter )
    {
        for( let [ label, value ] of Object.entries( activeFilter.filters ) )
        {
            if( ctx.ListOptions.filter[label] && value !== undefined && value !== null )
            {
                let $_value = ctx.ListOptions.filter[ label ].settings.multiple && !Array.isArray( value ) ? [ value ] : value;

                if( ctx.ListOptions.filter[label].hasOwnProperty('validator') )
                {
                    $_value = ctx.ListOptions.filter[label].validator( $_value );
                }

                $_filter[label] = $_value;
            }
        }
    }

    Object.assign( Helpers.ObjectClear( ctx.ListData.filter ), $_filter );

    if( ctx?.callback )
    {
        ctx.callback( Object.keys( $_filter ) );
    }
}

export const FilterPreset =
{
    create( settings, ctx )
    {
        if( !settings.filters ){ settings.filters = []; }

        for( let [ label, value ] of Object.entries( ctx.filter.filters ) )
        {
            if( Array.isArray( value ) && !value.length )
            {
                delete ctx.filter.filters[ label ];
            }
            else if( typeof value === "string" && !value.length )
            {
                delete ctx.filter.filters[ label ];
            }
        }

        if( Object.keys( ctx.filter.filters ).length )
        {
            settings.filters.push( ctx.filter );

            Helpers.Storage( undefined, 'set', ctx.storagePath, JSON.stringify( settings ) );
        }
    },

    update( settings, ctx )
    {
        let currPresetIndex = settings.filters.findIndex( p => p.id === ctx.filter.id );

        for( let [ label, value ] of Object.entries( ctx.filter.filters ) )
        {
            if( Array.isArray( value ) && !value.length )
            {
                delete ctx.filter.filters[ label ];
            }
            else if( typeof value === "string" && !value.length )
            {
                delete ctx.filter.filters[ label ];
            }
        }

        if( Object.keys( ctx.filter.filters ).length )
        {
            settings.filters[currPresetIndex] = ctx.filter;
        }
        else
        {
            settings.filters.splice( currPresetIndex, 1 );
        }

        Helpers.Storage(undefined, 'set', ctx.storagePath, JSON.stringify( settings ));
    },

    delete( settings, ctx )
    {
        let currPresetIndex = settings.filters.findIndex( p => p.id === ctx.filter.id );

        settings.filters.splice( currPresetIndex, 1 );

        Helpers.Storage(undefined, 'set', ctx.storagePath, JSON.stringify( settings ));

        ctx.filter.active && $_updateFilter( settings, ctx );
    },

    change( settings, ctx )
    {
        for( let filter of settings.filters )
        {
            filter.active = filter.id === ctx.id;
        }

        let customPreset = settings.filters.find( p => p.id === 'custom' );

        if( customPreset && !customPreset.active )
        {
            settings.filters = settings.filters.filter( p => p.id !== 'custom' );
        }

        Helpers.Storage(undefined, 'set', ctx.storagePath, JSON.stringify( settings ));

        $_updateFilter( settings, ctx );
    },

    extend( settings, ctx )
    {
        if( !settings.filters ){ settings.filters = []; }

        let shouldUpdate = false, currentPreset = settings.filters.find( p => p.active );

        if( !currentPreset )
        {
            currentPreset = { id: 'custom', name: 'Custom', active: true, filters: ctx.filter };

            settings.filters.push( currentPreset );

            shouldUpdate = true;
        }
        else
        {
            let diff = Helpers.ObjectDiff( currentPreset.filters, ctx.filter ); //TODO ked current filter ma pole s viac ako jednym prvkom, tak to nezoberie ako rozdiel

            if( Object.keys( diff ).length )
            {
                let $_filters = {};

                for( let [ label, value ] of Object.entries( currentPreset.filters ) )
                {
                    if( !ctx.filter.hasOwnProperty( label ) ){ $_filters[label] = value; continue; }

                    if( ctx.filter.hasOwnProperty( label ) && ctx.ignorePreviousFilters.includes( label ) ){ continue; }

                    if( Array.isArray( value ) || Array.isArray( ctx.filter[label] ) )
                    {
                        !Array.isArray( value )             && ( value = [ value ] );
                        !Array.isArray( ctx.filter[label] ) && ( ctx.filter[label] = [ ctx.filter[label] ] );

                        $_filters[label] = [ ...( new Set([ ...value, ...ctx.filter[label] ] ) ) ];
                    }
                    else if( typeof value === "string" || typeof value === "number" )
                    {
                        if( ( typeof ctx.filter[label] === "number" ) || ( typeof ctx.filter[label] === "string" && ctx.filter[label].length ) )
                        {
                            $_filters[label] = ctx.filter[label];
                        }
                    }
                }

                for( let [ label, value ] of Object.entries( ctx.filter ) )
                {
                    if( !$_filters.hasOwnProperty( label ) )
                    {
                        if( ( typeof value === "number" ) || ( typeof value === "string" && value.length ) || ( Array.isArray( value ) && value.length ) )
                        {
                            $_filters[label] = value;
                        }
                    }
                }

                if( currentPreset.id === 'custom' )
                {
                    currentPreset.filters = $_filters;
                }
                else
                {
                    let newPreset = { id: 'custom', name: 'Custom', active: true, filters: $_filters };

                    for( let preset of settings.filters ) { preset.active = false; }

                    settings.filters.push( newPreset );
                }

                shouldUpdate = true;
            }
        }

        if( shouldUpdate )
        {
            Helpers.Storage(undefined, 'set', ctx.storagePath, JSON.stringify( settings ));

            $_updateFilter( settings, ctx );

            if( ctx.allowFetch )
            {
                for( let [ label, value ] of Object.entries( ctx.filter ) )
                {
                    if( [ 'sort', 'cursor' ].includes( label ) ){ continue; }

                    let $_value = ctx.ListOptions.filter[label].settings.multiple && !Array.isArray( value ) ? [ value ] : value;

                    if( ctx.ListOptions.filter[label].hasOwnProperty('options') ) //TOTOK ASI REFAKTOR BO NAPIKACUUU
                    {
                        if( Array.isArray( $_value ) && !ctx.ListOptions.filter[label].options.find( option => $_value.includes( option.id ) ) )
                        {
                            if( ctx.ListOptions.filter[label]?.settings?.fetch )
                            {
                                ctx.ListOptions.filter[label].settings.fetch( ctx.store );
                            }
                            else if( ctx.ListOptions.filter[label]?.settings?.search )
                            {
                                ctx.ListOptions.filter[label].settings.search( ctx.store, '', $_value, () => {} ).then( options => ctx.ListOptions.filter[label].options = options );
                            }
                        }
                        else if( !Array.isArray( $_value ) && !ctx.ListOptions.filter[label].options.find( option => option.id === $_value ) )
                        {
                            if( ctx.ListOptions.filter[label]?.settings?.fetch )
                            {
                                ctx.ListOptions.filter[label].settings.fetch( ctx.store );
                            }
                            else if( ctx.ListOptions.filter[label]?.settings?.search )
                            {
                                ctx.ListOptions.filter[label].settings.search( ctx.store, '', [ $_value ], () => {} ).then( options => ctx.ListOptions.filter[label].options = options );
                            }
                        }
                    }
                }
            }
        }
    }
}

export const Filter =
{
    $_FilterObject: { ...$_FilterObject },

    extendFilterObject( filters ) //NOW USED ONLY WITHIN CUSTOM FILTERS
    {
        let $_fiterInputSetting =
        {
            label      : 'Example',
            group      : 'settings',
            options    : [],
            query      : {},
            settings   : { type: 'select', visibility: 'modal', searchable: true, multiple: true },
            $_fetch    : { type : 'custom' },
            //$_search   : { type : 'custom' },
            $_transform: {}
        }

        for( let filter of filters )
        {
            $_fiterInputSetting = JSON.parse( JSON.stringify( $_fiterInputSetting ) );

            $_fiterInputSetting.label               = filter.label;
            $_fiterInputSetting.query.property      = filter.id;
            $_fiterInputSetting.$_fetch.type        = filter.id;
            //$_fiterInputSetting.$_search.type       = filter.id;

            $_fiterInputSetting.$_transform['default']  = ( ids ) => { return { [ filter.parentPath ]: { [ filter.path ]: ids } } } // CUSTOM FILTERS ( parentPath, path is not existing on filters )

            Object.assign( this.$_FilterObject, { [ filter.id ]: $_fiterInputSetting } );
        }
    },

    resolveFilterObject( ListOptions, filter )
    {
        let $_filter = {};

        for( let [ label, value ] of Object.entries( filter ) )
        {
            if( ListOptions.filter[label] && typeof value !== 'undefined' && value !== null )
            {
                let $_value = ListOptions.filter[label].settings.multiple && !Array.isArray( value ) ? [ value ] : value;

                if( ListOptions.filter[label].hasOwnProperty('validator') )
                {
                    $_value = ListOptions.filter[label].validator( $_value );
                }

                if( $_value === 'true' || $_value === 'false' )
                {
                    $_value = $_value === 'true';
                }

                $_filter[label] = $_value;
            }
        }

        return $_filter;
    },

    getFilterQuery( filter, transformUID, transformToSmartFilter = true )
    {
        let $_query = { query: '', sort: {}, filter: [], $filter: [] };

        for( let [ key, value ] of Object.entries( filter ) )
        {
            if( key === 'sort' )
            {
                $_query.sort = value;
            }
            else if( key === 'search' )
            {
                $_query.query = value;
            }
            else if( this.$_FilterObject.hasOwnProperty( key ) )
            {
                let $_transform     = this.$_FilterObject?.[key]?.['$_transform']?.[transformUID] || this.$_FilterObject[key]['$_transform']['default'];
                let $_transformData = $_transform( Array.isArray( value ) ? value : [ value ] );

                //Helpers.ObjectMerge( $_query.filter, $_transform( Array.isArray( value ) ? value : [ value ] ) );

                if( $_transformData?.$filter )
                {
                    $_query.$filter.push( $_transformData.$filter );
                }
                else
                {
                    $_query.filter.push( $_transformData );
                }
            }
        }

        if( !$_query.query.length )
        {
            delete $_query.query;
        }

        if( !Object.keys( $_query.sort ).length )
        {
            delete $_query.sort;
        }

        if( $_query.$filter.length ) { $_query.$filter = $_combineFilters( ...$_query.$filter ); }
        else { $_query.$filter = {}; }

        if( $_query.filter.length ) { $_query.filter = $_combineFilters( ...$_query.filter ); }
        else { $_query.filter = {}; }

        if( transformToSmartFilter )
        {
            $_query.smartFilter = JSON.parse( JSON.stringify( $_query.filter ) );
            $_query.filter      = JSON.parse( JSON.stringify( $_query.$filter ) );
        }

        //$_query.filter = JSON.stringify( $_query.filter );

        return Helpers.ObjectClean( $_query );
    },

    getHiddenFilter( uid, filter )
    {
        if( this.$_FilterObject.hasOwnProperty( filter ) )
        {
            let $_filters = JSON.parse(JSON.stringify(this.$_FilterObject[ filter ]));

            if( this.$_FilterObject[filter].hasOwnProperty('$_transform') )
            {
                $_filters.transform = this.$_FilterObject[filter]['$_transform'][`${uid}`] || this.$_FilterObject[filter]['$_transform']['default'];

                delete $_filters['$_transform'];
            }

            return $_filters;
        }
    },

    resolveFilterItem( filter, settings, resolveObject )
    {
        let validateFilter = ( filter ) =>
        {
            let deletedFilters = [];

            if( Array.isArray( settings.list.filter[ filter ] ) )
            {
                const filteredArray = settings.list.filter[filter].filter( id => settings.options.filter[filter].options.find( option => option.id === id ) );

                const isDifferent = filteredArray.length !== settings.list.filter[filter].length || filteredArray.some( ( id, index ) => id !== settings.list.filter[filter][index] );

                if( isDifferent )
                {
                    settings.list.filter[filter] = filteredArray;

                    if( !settings.list.filter[filter].length )
                    {
                        deletedFilters.push( filter );

                        delete settings.list.filter[filter];
                    }
                }
            }
            else if( settings.list.filter[ filter ] && !settings.options.filter[filter].options.find( option => option.id === settings.list.filter[ filter ] ) )
            {
                deletedFilters.push( filter );

                delete settings.list.filter[ filter ];
            }

            if( settings?.options?.filter?.[ filter ]?.settings?.fetch && !settings?.list?.filter?.[ filter ] && settings?.options?.defaultFilters[ filter ] )
            {
                let defaultValues = Helpers.toArray( settings.options.defaultFilters[filter] );

                for( let value of defaultValues )
                {
                    if( settings.options.filter[filter].options.find( option => option.id === value ) )
                    {
                        if( !settings.list.filter[ filter ] )
                        {
                            settings.list.filter[ filter ] = [];
                        }

                        settings.list.filter[ filter ].push( value );
                    }
                }
            }

            if( deletedFilters.length )
            {
                setTimeout( () =>
                {
                    let $_activeFilterPreset = settings.list?.settings?.filters?.find( f => f.active );

                    if( $_activeFilterPreset )
                    {
                        settings.$router.replace({ query: { ...settings.$router.currentRoute.value.query, ...deletedFilters.reduce( ( obj, item ) => ( { ...obj, [item]: undefined } ), {} ) } });

                        let $_filter = { ...JSON.parse( JSON.stringify( $_activeFilterPreset ) ), filters: { ...$_activeFilterPreset.filters, ...deletedFilters.reduce( ( obj, item ) => ( { ...obj, [item]: undefined } ), {} ) } }

                        FilterPreset.update( settings.list?.settings, { storagePath: `${settings.storagePath}_settings`, filter: $_filter });
                    }

                    if( settings.callback )
                    {
                        settings.callback();
                    }

                }, 0 );
            }
        }

        let $_ranges = async( uid, filter, type ) =>
        {
            //TODO
        }

        let $_fetch = async( store, filter, type ) =>
        {
            settings.options.filter[filter].options = await store.dispatch( 'ramp/base/select/resolve', [ type ]) .then( r => r[type] );

            validateFilter( filter );
        }

        let $_search = async( store, query, selectedItems, loading, filter, type ) =>
        {
            //TOTO NEVIEM CI DOBRE SOM ZROBIL
            if( selectedItems && !Array.isArray( selectedItems ) )
            {
                selectedItems = [ selectedItems ];
            }

            if( settings.list.filter[filter] && !Array.isArray( settings.list.filter[filter] ) )
            {
                settings.list.filter[filter] = [ settings.list.filter[filter] ];
            }

            if( query.length || settings.list?.filter?.[filter]?.length )
            {
                loading( true );

                settings.options.filter[filter].options = await store.dispatch( 'ramp/base/select/options',
                {
                    type   : type,
                    filter : { include: { ids: [ ...new Set([ ...( settings.list.filter[filter] || [] ), ...( selectedItems || [] ) ]) ], query, ...( settings.options.filter[filter]?.query || {} ) } }
                });

                loading( false );
            }

            setTimeout( () => { validateFilter( filter ); }, 1000 );

            return settings.options.filter[filter].options;
        }

        if( filter === 'sort' && this.$_FilterObject.hasOwnProperty( filter ) )
        {
            Object.assign( resolveObject.sort,
            {
                label   : this.$_FilterObject[ filter ].label,
                settings: this.$_FilterObject[ filter ].settings,
                options : this.$_FilterObject[ filter ]?.[settings.uid]?.options || this.$_FilterObject[ filter ].default.options
            })
        }
        else if( this.$_FilterObject.hasOwnProperty( filter ) )
        {
            resolveObject.filter[filter] = JSON.parse(JSON.stringify(this.$_FilterObject[ filter ]));

            if( settings.options?.overrideFilters?.hasOwnProperty( filter ) )
            {
                if( settings.options.overrideFilters[filter]?.settings )
                {
                    Object.assign( resolveObject.filter[filter].settings, settings.options.overrideFilters[filter].settings );
                }
            }

            if( settings.options?.initialFilters?.includes( filter ) )
            {
                resolveObject.filter[filter].settings.visibility = 'immediately';
            }

            if( this.$_FilterObject[filter].hasOwnProperty('$_search') )
            {
                resolveObject.filter[filter].settings.search = async ( store, query, selectedItems, loading ) => await $_search( store, query, selectedItems, loading, filter, this.$_FilterObject[filter]['$_search'].type );

                delete resolveObject.filter[filter]['$_search'];
            }

            if( this.$_FilterObject[filter].hasOwnProperty('$_fetch') )
            {
                resolveObject.filter[filter].settings.fetch = async ( store ) => await $_fetch( store, filter, this.$_FilterObject[filter]['$_fetch'].type );

                delete resolveObject.filter[filter]['$_fetch'];

                if( settings.autoFetch )
                {
                    resolveObject.filter[filter].settings.fetch( settings.store );
                }
            }

            if( this.$_FilterObject[filter].hasOwnProperty('$_component') )
            {
                let $_component = {};

                if( this.$_FilterObject[filter]['$_component'].hasOwnProperty('option') )
                {
                    $_component.option = shallowRef( defineAsyncComponent( async () => await this.$_FilterObject[filter]['$_component']['option']() ) );
                }

                if( this.$_FilterObject[filter]['$_component'].hasOwnProperty('props') )
                {
                    $_component.props = this.$_FilterObject[filter]['$_component']['props'];
                }

                resolveObject.filter[filter].component = $_component;

                delete resolveObject.filter[filter]['$_component'];
            }

            if( this.$_FilterObject[filter].hasOwnProperty('$_transform') )
            {
                resolveObject.filter[filter].transform = this.$_FilterObject[filter]['$_transform'][`${settings.uid}`] || this.$_FilterObject[filter]['$_transform']['default'];

                delete resolveObject.filter[filter]['$_transform'];
            }

            if( this.$_FilterObject[filter].hasOwnProperty('$_validator') )
            {
                resolveObject.filter[filter].validator = this.$_FilterObject[filter]['$_validator'];

                delete resolveObject.filter[filter]['$_validator'];
            }

            if( this.$_FilterObject[filter].hasOwnProperty('$_validator') )
            {
                resolveObject.filter[filter].validator = this.$_FilterObject[filter]['$_validator'];

                delete resolveObject.filter[filter]['$_validator'];
            }
        }
        else
        {
            console.error( `Filter ${filter} does not exist!` );
        }
    },

    createObject( uid, list, options, filterList, storagePath, $router, callback )
    {
        let $_sort = {}, $_filters = {};

        for( let filter of filterList )
        {
            this.resolveFilterItem( filter, { uid, list, options, storagePath, $router, callback }, { sort: $_sort, filter: $_filters } );
        }

        return reactive({ sort: $_sort, filter: $_filters });
    }
}